import { createAsyncLimiter } from "@istari-frontend/shared";

export const zipOperationQueue = createAsyncLimiter(1);
